import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Field from '../Field';
import CheckBox from '../CheckBox';

export default class CheckBoxField extends React.Component {
  static propTypes = {
    valueField: PropTypes.object.isRequired,
    value: PropTypes.any,
    children: PropTypes.node,
  };

  static defaultProps = {
    value: undefined,
    children: undefined,
  };

  handleChange = event => {
    const { valueField, value } = this.props;
    const { onChange } = valueField;

    const checked = get(event, 'target.checked');

    if (checked) {
      onChange(value || checked);
    } else {
      onChange(value ? '' : false);
    }
  };

  render() {
    const { children, ...props } = this.props;
    const { value } = this.props.valueField;

    return (
      <Field {...props} onChange={this.handleChange} checked={!!value}>
        <CheckBox>{children}</CheckBox>
      </Field>
    );
  }
}
